export default "__VITE_ASSET__DVcyt6VO__"